<template>
  <div class="hc-art home-border">
    <ul>
      <li
        v-for="(item, index) in defaultList"
        class="art-info"
        :key="'defaultList' + index"
        @click="gotoTemp(item)"
      >
        <div class="default-banner" :style="item.style">
          <p>{{ item.name }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Home } from "@/config/axios/new_api";
export default {
  data() {
    return {
      defaultList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
        let res = await Home.getData({ type: 2 })
        if (Array.isArray(res.data) && res.data.length) {
        this.defaultList = res.data.map((item) => {
            item.style = `background-image: url(${item.url})`;
            return item;
        });
        }
    },
    gotoTemp(item) {
      if (item.path_type === 1) {
        this.$router.push({
          name: "TemplateList",
          query: {
            id: item.directories_id,
            name: item.name,
            type: "icon",
          },
        });
      } else {
        this.goDesignworkbench(item, item.template_id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hc-art {
  @include wh(536px, 304px);
  float: right;
  padding: 0;
  .art-info {
    @include wh(248px, 132px);
    float: left;
    margin: 10px;
  }
  ul {
    @include wh(100%, 100%);
  }
}
.default-banner {
  @include wh(100%, 100%);
  border-radius: 8px;
  position: relative;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  background-position: center;
  background-size: 100% 100%;
  p {
    position: absolute;
    left: 30px;
    bottom: 30px;
  }
}
</style>
